/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable consistent-return */

import React, { useRef, useState, useEffect, useCallback } from 'react';
import CardNews from 'components/atoms/card_news';
import { PanelState } from 'store/modules/panel_store/types';
import { ApplicationState } from 'store';
import { useSelector } from 'react-redux';
import { ProfileState } from 'store/modules/profile_store/types';
import BannerRadarModal from 'components/molecules/banner_radar_modal';
import BannerBondModal from 'components/molecules/banner_bond_modal';
import ModalDrlicita from 'components/atoms/modal_drlicita';
import ModalRobo from 'components/atoms/modal_robo';
import ModalBiddingViewed from 'components/atoms/modal_bidding_viewed';
import BannerBiddingSummaryModal from 'components/molecules/banner_bidding_summary';
import BannerChatbotModal from 'components/molecules/banner_chatbot_modal';
import BannerAuthenticateDocumentModal from 'components/molecules/banner_authenticate_document_modal';
import ConlicitasegModalBetaTester from 'components/molecules/conlicitaseg_modal_beta_tester';
import createTrack from 'services/actions/tracker_actions';
import { newsItems } from './news_data';
import { Container } from './styles';

const modalMap: Record<string, React.FC<{ show: boolean; onClose: () => void }>> = {
  BannerRadarModal,
  BannerBondModal,
  ModalDrlicita,
  ModalRobo,
  ModalBiddingViewed,
  BannerBiddingSummaryModal,
  BannerChatbotModal,
  BannerAuthenticateDocumentModal,
  ConlicitaSeg: ConlicitasegModalBetaTester,
};

const NewsSession = () => {
  const carouselRef = useRef<HTMLDivElement>(null);
  const [activeIndex, setActiveIndex] = useState(0);
  const [showLeftArrow, setShowLeftArrow] = useState(false);
  const [showRightArrow, setShowRightArrow] = useState(false);
  const [activeModal, setActiveModal] = useState<string | null>(null);

  const { panel } = useSelector<ApplicationState, PanelState>((state) => state.session.panel);
  const { profile } = useSelector<ApplicationState, ProfileState>((state) => state.storage.profile);

  const permissions = {
    ...panel,
    ...profile,
  };

  const handleOpenModal = (modal: string) => {
    setActiveModal(modal);
    createTrack('Clicou em um banner de Novidades', { fonte: modal });
  };

  const handleCloseModal = () => {
    setActiveModal(null);
  };

  const handleScroll = useCallback(() => {
    const container = carouselRef.current;
    if (!container) return;

    const { scrollLeft, scrollWidth, clientWidth } = container;
    const cardWidth = container.querySelector('.news-slide')?.clientWidth || 1;

    setActiveIndex(Math.round(scrollLeft / cardWidth));
    setShowLeftArrow(scrollLeft > 0);
    setShowRightArrow(scrollLeft < scrollWidth - clientWidth - 5);
  }, []);

  const scroll = useCallback((direction: 'left' | 'right') => {
    const container = carouselRef.current;
    if (!container) return;

    const cardWidth = container.querySelector('.news-slide')?.clientWidth || 300;
    container.scrollBy({
      left: direction === 'right' ? cardWidth : -cardWidth,
      behavior: 'smooth',
    });
  }, []);

  const scrollToIndex = useCallback((index: number) => {
    const container = carouselRef.current;
    if (!container) return;

    const card = container.querySelectorAll('.news-slide')[index] as HTMLElement;
    if (card) {
      container.scrollTo({
        left: card.offsetLeft,
        behavior: 'smooth',
      });
    }
  }, []);

  const hasAccess = (keys?: string[]): boolean => {
    if (!keys || keys.length === 0) return true;
    return keys.some((key) => permissions[key as keyof typeof permissions]);
  };

  useEffect(() => {
    const container = carouselRef.current;
    if (!container) return;

    const hasOverflow = container.scrollWidth > container.clientWidth;
    setShowRightArrow(hasOverflow);

    container.addEventListener('scroll', handleScroll);
    return () => container.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  const visibleItems = newsItems.filter((item) => hasAccess(item.accessKey));
  const showArrows = visibleItems.length > 4;
  const ModalComponent = activeModal ? modalMap[activeModal] : null;

  return (
    <Container className="pt-3">
      <h4>Novidades</h4>
      <div className={`position-relative ${showArrows ? 'my-md-2 px-md-4' : ''}`}>
        {showArrows && (
          <>
            <div
              className={`carousel-arrow left d-none d-md-flex ${!showLeftArrow ? 'disabled' : ''}`}
              onClick={() => scroll('left')}
            >
              <span className="oi oi-chevron-left" />
            </div>
            <div
              className={`carousel-arrow right d-none d-md-flex ${
                !showRightArrow ? 'disabled' : ''
              }`}
              onClick={() => scroll('right')}
            >
              <span className="oi oi-chevron-right" />
            </div>
          </>
        )}
        <div className={`news-carousel py-3 ${showArrows ? 'mx-md-4' : ''}`} ref={carouselRef}>
          {visibleItems.map((item) => (
            <div className="news-slide position-relative" key={`news-${item.modal}`}>
              <CardNews {...item} onClick={handleOpenModal} />
            </div>
          ))}
        </div>
        {visibleItems.length > 1 && (
          <div className="carousel-dots d-md-none mt-3">
            {visibleItems.map((item, index) => (
              <span
                key={`dot-${item.modal}`}
                className={`dot ${index === activeIndex ? 'active' : ''}`}
                onClick={() => scrollToIndex(index)}
              />
            ))}
          </div>
        )}
      </div>

      {ModalComponent && <ModalComponent show={!!activeModal} onClose={handleCloseModal} />}
    </Container>
  );
};

export default NewsSession;
